import { Configuration } from "src/types/configuration";

export const getConfigurationHash = () => {
  const configurationHashEl = document.getElementById("configuration-hash");

  if (configurationHashEl) {
    const hash = configurationHashEl.getAttribute("value") ?? "";

    if (hash) {
      try {
        const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/;
        let json = hash;

        if (base64Regex.test(hash)) {
          json = atob(hash);
        }

        return json;
      } catch (e) {
        console.error("Failed to parse configuration JSON:", e);
        return "";
      }
    }

    return "";
  }

  return "";
};

export const calculateKapschuurRoofBigSideLength = (state: Configuration) => {
  const angleRadians = (state.params.kapschuurOverhangBigAngle * Math.PI) / 180;

  return state.dimensions.depth / Math.cos(angleRadians);
};

export const calculateKapschuurBigHeight = (state: Configuration) => {
  const h = calculateKapschuurRoofBigSideLength(state);
  const a = state.dimensions.depth;

  return state.params.kapschuurSmallHeight + Math.sqrt(h * h - a * a);
};
